import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { ServerEvent } from "@/Common/Stores/Actions/ServerEvent";
import { BaseStore } from "@/Common/Stores/BaseStore";
import { RequestMapper, ServerResponseMapper } from "@/Common/Stores/Handlers/Server/RequestMapper";
import { CommunicationsHelper } from "@/Communications/Helpers/CommunicationsHelper";
import { SendRecallAction } from "@/Communications/Stores/Actions/SendRecallAction";
import { SendTaskOrMessageAction } from "@/Communications/Stores/Actions/taskPopupAction";
import { SendRecallPopupHandler } from "@/Communications/Stores/Handlers/Local/SendRecallPopupHandler";
import { SendTaskOrMessagePopupHandler } from "@/Communications/Stores/Handlers/Local/SendTaskPopupHandler";
import { GlobalSendCommunicationResponseHandler } from "@/Communications/Stores/Handlers/Server/GlobalSendCommunicationResponseHandler";
import { ISendRecallPopupModel } from "../Models/UI/IRecallPopupModel";
import { ISendTaskOrMessagePopupModel } from "../Models/UI/ITaskMessagePopupModel";

let defaultInstance: GlobalSendCommunicationStore;

class GlobalSendCommunicationStore extends BaseStore {
    private SendTaskOrMessageHandler: SendTaskOrMessagePopupHandler;
    private SendRecallHandler: SendRecallPopupHandler;
    private ResponseHandler: GlobalSendCommunicationResponseHandler;
    private RecallResponseHandler: GlobalSendCommunicationResponseHandler;

    private Mapper: RequestMapper;
    private ServerMapper: ServerResponseMapper;

    public MessageTaskActions: SendTaskOrMessageAction;
    public RecallActions: SendRecallAction;

    public SendTaskOrMessageModel: ISendTaskOrMessagePopupModel;
    public SendRecallPopupModel: ISendRecallPopupModel;

    constructor() {
        super();
        var self = this;

        this.MessageTaskActions = new SendTaskOrMessageAction();
        this.RecallActions = new SendRecallAction();

        this.SendTaskOrMessageHandler = new SendTaskOrMessagePopupHandler();
        this.SendRecallHandler = new SendRecallPopupHandler();

        this.Mapper = new RequestMapper();

        this.Mapper.AddInstance(this.SendTaskOrMessageHandler);
        this.Mapper.AddInstance(this.SendRecallHandler);

        this.SendTaskOrMessageModel = Immutable.fromJS(CommunicationsHelper.GetDefaultTaskMessagePopupModel());
        this.SendRecallPopupModel = Immutable.fromJS(CommunicationsHelper.GetDefaultRecallPopupModel());

        this.ServerMapper = new ServerResponseMapper();
        this.ResponseHandler = new GlobalSendCommunicationResponseHandler(this.MessageTaskActions);
        this.ServerMapper.AddInstance(this.ResponseHandler);

        this.RecallResponseHandler = new GlobalSendCommunicationResponseHandler(this.RecallActions);
        this.ServerMapper.AddInstance(this.RecallResponseHandler);

        this.ServerDispatchToken = ServerResponseDispatcher.register((response: ServerEvent) => { self.ServerMapper.Map(response, self); });

        this.ClientDispatchToken = LocalEventDispatcher.register((request: LocalEvent) => self.Mapper.Map(request, self));
    }

    public static createSingleton(): GlobalSendCommunicationStore {
        return this.createStoreSingleton(defaultInstance, () => defaultInstance = new GlobalSendCommunicationStore());
    }

    public static createSingletonFrom(store: GlobalSendCommunicationStore, copy: boolean = true): GlobalSendCommunicationStore {
        return copy
            ? Object.assign(this.createSingleton(), store)
            : this.createStoreSingleton(defaultInstance, () => defaultInstance = store);
    }

    public ResetTaskMessageModel(): void {
        this.SendTaskOrMessageModel = Immutable.fromJS(CommunicationsHelper.GetDefaultTaskMessagePopupModel());
    }

    public ResetRecallModel(): void {
        this.SendTaskOrMessageModel = Immutable.fromJS(CommunicationsHelper.GetDefaultTaskMessagePopupModel());
    }
}

export { GlobalSendCommunicationStore, defaultInstance as globalSendCommunicationStore };
